import { EventType } from "interfaces";
import {
  BuildEventPageStep,
} from "./components";
import { StepsMenu } from "components/shared/event";

export const CreateAttractionEvent: React.FC = () => {

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="shrink-0">
        <StepsMenu eventType={EventType.ATTRACTION} isEdit={false} />
      </div>
      <div className="flex-1"><BuildEventPageStep /></div>
    </div>
  );
};
